import {action, observable, runInAction} from 'mobx'
import {
    clearForm,
    getReplyList,
    handleSearchAndPage,
    objToUrlParams,
    setStore,
    ValueObjToObj
} from "../../../../utils/Utils";
import {json} from "../../../../utils/ajax";
import {message} from "antd/lib/index";
import BraftEditor from 'braft-editor'

class answerCenterStore {
    @observable loading  //答疑中心loading
    @observable list  //答疑中心列表
    @observable pagination  //答疑中心列表分页好评率
    @observable searchField  //主页面搜索表单绑值
    @observable carseries  //主页面车系下拉框
    @observable multipleSelectedRows  //多条删除
    @observable mainGroupCodeList //主组号
    @observable groupCode //分组号
    @observable selectList //下拉框数据
    @observable selectMenu //设置案例数据来源 过滤掉案例，push经典案例
    @observable classicSelectMenu //设置案例数据来源 ，push经典案例

    /**********主题回复*************/
    @observable isCheck  //是否审核  0审核，1未审核
    @observable isAccept  //是否采纳  0采纳，1未采纳
    @observable replyItem  //显示对应回复文本框
    @observable replyList  //回复数据
    @observable reviewSubject  //主题区表格数据
    @observable subjectId  //当前选中主题的id
    @observable replySubject  //主题发表内容
    @observable fileList //上传文件
    @observable editModalVisible //修改模态框属性显示
    @observable editEditorValue //修改模态框内容
    @observable subject
    @observable haveNewCommentList
    @observable questionTypeList  //问题类型
    @observable questionTypeName  //问题类型的名字
    @observable editorContent

    constructor() {
        this.loading = false
        this.list = []
        this.pagination = {
            current: 0,
            total: 1,
            showQuickJumper: true,
            showSizeChanger: true,
            pageSize: 20,
            showTotal: () => {
            }
        }
        this.searchField = {
            carseriesCode: '',
            subject: '',
            type: '',
            mainGroupCode: '',
            groupCode: '',
            emergencyLevel: '',
            serviceCode: '',
            haveNewComment: '',
        }
        this.carseries = []
        this.multipleSelectedRows = []
        this.mainGroupCodeList = []
        this.groupCode = []
        this.selectList = []
        this.selectMenu = []
        this.classicSelectMenu = []

        /**********主题回复*************/
        this.isCheck = ''
        this.isAccept = ''
        this.replyItem = ''
        this.reviewSubject = {}
        this.replyList = []
        this.subjectId = ''
        this.haveNewCommentList = [{name: '是', value: 'Y'}, {name: '否', value: 'N'}]
        this.replySubject = {
            subjectId: '',
            pId: '0',
            level: 1,
            id: '',
            senderLogName: '',
            senderUserName: '',
            commentText: '',
            photo: '',
            attachment: '',
            attachmentName: '',
            sort: '',
            commentedUserName: '',
            commentedId: '',
            senderUserPhoto: ''
        }
        this.fileList = []
        this.editModalVisible = false
        this.editEditorValue = {
            commentText: BraftEditor.createEditorState(null)
        }
        this.subject = {}
        this.questionTypeList = []
        this.questionTypeName = ''
        this.editorContent = null
    }

    /**调用setStore方法并传入当前this***/
    @action
    setStore = (obj) => {
        setStore(obj, this)
    }

    /**页面初始化*/
    @action
    initPage = async (page) => {
        this.loading = true
        let searchField = {
            ...this.searchField,
            carseriesCode: this.searchField.carseriesCode ? this.searchField.carseriesCode : '',
            subject: this.searchField.subject ? this.searchField.subject : '',
            type: this.searchField.type ? this.searchField.type : '',
            mainGroupCode: this.searchField.mainGroupCode ? this.searchField.mainGroupCode.split('/')[1] : '',
            groupCode: this.searchField.groupCode ? this.searchField.groupCode : '',
            emergencyLevel: this.searchField.emergencyLevel ? this.searchField.emergencyLevel : '',
            serviceCode: this.searchField.serviceCode ? this.searchField.serviceCode : '',
            replyStatus: this.searchField.replyStatus ? this.searchField.replyStatus : '',
            haveNewComment: this.searchField.haveNewComment ? this.searchField.haveNewComment : '',
        }
        let search = handleSearchAndPage(page, this.pagination, searchField)
        let res = await json.get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/answerPlatform/answerCenter/getAnswerCenterPage:search`, search)
        runInAction(() => {
            this.list = res.content ? res.content : []
            this.pagination = {
                current: res.number + 1,
                total: res.totalElements,
                showQuickJumper: true,
                showSizeChanger: true,
                pageSize: res.size,
                showTotal: () => `总共 ${res.totalElements} 条`
            }
            this.loading = false
        })
    }

    /***问题类型**/
    @action
    getQuestionType = async () => {
        let res = await json.get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/dictionary/getOneRoot`, {name: '问题类型/'})
        runInAction(()=> {
            this.questionTypeList = Array.isArray(res.children) ? res.children : []
        })
    }

    /***搜索表单、列表新增绑值**/
    @action
    onFormField = (changedFields, fields) => {
        const change = ValueObjToObj(changedFields)
        this[fields] = {...this[fields], ...change}
    }

    /**请求车系**/
    @action
    carSeries = async (e) => {
        this.questionTypeName = e ? e : ''
        const res = await json.get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/answerPlatform/answerCenter/moduleNameQueryCarSeriesTable/${e}`)
        runInAction(() => {
            this.carseries = Array.isArray(res) ? res : []
        })
    }

    /***搜索框下拉数据 ***/
    @action
    initAddSelect = async () => {
        const res = await json.post(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/answerPlatform/answerCenter/selectData`)
        runInAction(() => {
            this.selectList = Array.isArray(res) ? res : []
        })
    }

    /****根据车系选择主组号***/
    @action
    getMainGroupCode = async (value) => {
        const res = await json.post(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/answerPlatform/answerCenter/directory?carseriesCode=${value}`)
        runInAction(() => {
            this.mainGroupCodeList = Array.isArray(res) ? res : []
        })
    }

    /****根据主组号选择分组号***/
    @action
    getGroupCode = async (carseriesCode, values) => {
        const id = values.split('/')[0]
        const res = await json.get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/verification/queryLvThreeCatalogs/carseriesCode?carseriesCode=${carseriesCode}&lv2Id=${id}`)
        runInAction(() => {
            this.groupCode = Array.isArray(res) ? res : []
        })
    }

    /**主页面搜索重置**/
    @action
    handleReset = () => {
        this.searchField = clearForm(this.searchField)
        this.mainGroupCodeList = []
        this.groupCode = []
        this.questionTypeName = ''
        this.initPage()
    }

    /**设置案例数据来源***/
    @action
    selectSubModel = async () => {
        const res = await json.get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/answerPlatform/answerCenter/selectSubModel`)
        runInAction(() => {
            if (res.status === 0) {
                return
            }
            this.selectMenu = res.filter(item => item !== '案例')
            this.selectMenu.push({name: '经典案例'})
            this.classicSelectMenu = Array.isArray(res) ? res : []
            this.classicSelectMenu.push({name: '经典案例'})
        })
    }

    @action
    setCase = async (id, setCaseCheckedValues) => {
        let obj = {
            id: id,
            exampleType: setCaseCheckedValues.join(',')
        }
        const res = await json.post(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/answerPlatform/answerCenter/setExampleType?${objToUrlParams(obj)}`,)
        if (res.status === 1) {
            runInAction(() => {
                message.success('设置成功')
            })
        }
        this.initPage(this.pagination.current)
    }

    /***审核主题***/
    @action
    checkSubject = async (id) => {
        this.loading = true
        await json.post(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/answerPlatform/answerCenter/approvalCheck/${id}`)
        runInAction(() => {
            this.loading = false
        })
        message.success('主题审核成功')
        this.initPage(this.pagination)
    }

    /**删除单条**/
    @action
    deleteOne = async (id) => {
        this.loading = true
        let ids = []
        ids.push(id)
        await json.post(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/answerPlatform/answerCenter/deleteByIds`, ids)
        runInAction(() => {
            this.loading = false
        })
        message.success('删除成功')
        this.initPage(this.pagination)
    }

    /**删除多条**/
    @action
    multipleDelete = async (ids) => {
        this.loading = true
        await json.post(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/answerPlatform/answerCenter/deleteByIds`, ids)
        runInAction(() => {
            this.loading = false
        })
        message.success('删除成功')
        this.initPage(this.pagination)
    }

    @action
    shareOne = async (id, status) => {
        await json.post(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/answerPlatform/answerCenter/modifySharedStatus?id=${id}&sharedStatus=${status}`)
        this.initPage(this.pagination)
    }

    /********************主题回复**************************************************************************/
    /***页面初始化***/
    @action
    initReviewData = async (id) => {
        this.loading = true
        this.editorContent = null
        const res = await json.get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/answerPlatform/answerCenter/showAnswerCenter/${id}`)   //获取主题区数据
        const res1 = await json.get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/answerPlatform/answerCenterComment/getTree?subjectId=${id}&frontOrBack=back`)  //获取回复树数据
        // const res1 = await json.get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/answerPlatform/answerCenterComment/getTree?subjectId=${id}`)  //获取回复树数据
        let replyList = []
        res1 && res1.forEach(item => {
            const obj = {...item, list: []}
            getReplyList(item.children, obj.list, item.senderUserName)
            replyList.push(obj)
        })
        runInAction(() => {
            this.reviewSubject = res
            this.replyList = replyList
            this.isCheck = res.isCheck
            this.isAccept = res.isAccept
            this.replySubject = {
                ...this.replySubject,
                subjectId: id,
                commentedId: id,
                commentedUserName: res.postUserName
            }
            this.loading = false
        })
    }

    /***删除回复**/
    @action
    deleteReplay = async (id) => {
        const res = await json.post(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/answerPlatform/answerCenterComment/delCommentByCommentId/${id}`)
        if (!res.status) {
            message.error('采纳前的回复，禁止删除')
            return
        }
        message.success('删除成功')
        this.initReviewData(this.subjectId)
    }

    /**审核***/
    @action
    checkClick = async (id) => {
        this.loading = true
        await json.post(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/answerPlatform/answerCenter/approvalCheck/${id}`)
        runInAction(() => {
            this.isCheck = 1
            this.loading = false
        })
        message.success('审核成功！')
        this.initReviewData(this.subjectId)
    }

    /**采纳***/
    @action
    setAccept = async (commentId, subjectId) => {
        this.loading = true
        await json.post(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/answerPlatform/answerCenter/commentId/${commentId}/id/${subjectId}`)
        runInAction(() => {
            this.isAccept = 1
            this.replyItem = ''
            this.loading = false
        })
        message.success('已采纳！')
        this.initReviewData(this.subjectId)
    }

    /***回复replyWho=''/  发布replyWho='replySubject' ***/
    @action
    replyContent = async (comment) => {
        this.loading = true
        await json.post(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/answerPlatform/answerCenterComment/add`, comment)
        runInAction(() => {
            this.replyItem = ''
            this.loading = false
            this.replySubject.attachment = ''
            this.replySubject.attachmentName = ''
            this.editorContent = null
        })
        this.initReviewData(this.subjectId)
    }

    /*** 设置上传文件列表***/
    @action
    setFileList(fileList) {
        this.fileList = fileList
    }

    /**编辑某一主题的回复***/
    @action
    editEditor = async () => {
        this.confirmLoading = true
        this.loading = true
        await json.post(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/answerPlatform/answerCenterComment/edit`, this.editEditorValue)
        runInAction(() => {
            this.editEditorValue = {}
            this.editModalVisible = false
            this.confirmLoading = false
            this.loading = false
        })
        message.success('编辑成功')
        this.initReviewData(this.subjectId)
    }

    /**
     * 富文本编辑器的内容改变
     * @param value
     */
    @action
    handleEditorChange = (value) => {
        this.editorContent = value
    }
}

export default new answerCenterStore()


// WEBPACK FOOTER //
// ./src/Backend/dongfeng/AnswerPlatform/AnswerCenter/store.js